import styles from "./Heading.module.css";

function Heading({title, action}) {
    return (
       <div className={styles.heading__Body}>
        <div className={styles.heading__row}>
            <h1 className={styles.heading}>{title}</h1>
            {action && <div className={styles.heading__action}>{action}</div>}
        </div>
        <hr className='horizontal-ruler' />
       </div>
    )
}

export default Heading;